import { useLingui } from '@lingui/react/macro';
import { Box, Stack } from '@mui/material';
import Tooltip from '@watershed/ui-core/components/Tooltip';

import { calculatePercentInt } from '@watershed/shared-util/src/mathUtils';
import CircularProgress from '@watershed/ui-core/components/CircularProgress';

import { getProjectProgressTooltipMsg } from './projectStrings';

export default function ProjectProgress({
  numCompleted,
  numTotal,
}: {
  numCompleted: number;
  numTotal: number;
}) {
  const { i18n } = useLingui();
  // We show a checkmark if 0/0
  const noTasksAsIncomplete = numTotal === 0;
  const percent = calculatePercentInt(numCompleted, numTotal);
  const tooltip = i18n._(getProjectProgressTooltipMsg(numCompleted, numTotal));

  return (
    <Tooltip title={tooltip}>
      <Stack direction="row" alignItems="center" gap={1}>
        <Box aria-hidden={true} display="flex" alignItems="center">
          <CircularProgress
            hasOutline
            showCheckmarkOnComplete={!noTasksAsIncomplete}
            variant="determinate"
            thickness={6}
            size={16}
            value={noTasksAsIncomplete ? 0 : percent}
          />
        </Box>
        {numCompleted}/{numTotal}
      </Stack>
    </Tooltip>
  );
}
